<template>
  <v-container class="py-8" style="max-width: 800px">
    <v-btn variant="text" class="mb-4" :to="backTarget">&larr; Back</v-btn>
    <h1 class="text-h4 mb-2">Terms of Service</h1>
    <p class="text-body-2 text-medium-emphasis mb-6">Last updated September 16, 2026</p>

    <p>
      These Terms of Service ("Terms") govern access to and use of Gigdriver (the "Service"), operated by
      Audionola ("Audionola", "we", "us"). By creating an account or using the Service, you agree to these Terms.
    </p>

    <h2 class="text-h6 mt-6 mb-2">The Service</h2>
    <p>
      Gigdriver is a gig booking and staffing management tool that lets organizations post staffing
      positions, offer and accept bookings, track budgets, and coordinate scheduling with staff.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Accounts</h2>
    <p>
      You are responsible for maintaining the security of your account credentials and for activity that
      occurs under your account. You must provide accurate information when creating an account.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Acceptable use</h2>
    <p>
      You agree not to misuse the Service — including attempting to access data you're not authorized to
      see, disrupting the Service, or using it for any unlawful purpose.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Bookings between organizations and staff</h2>
    <p>
      Gigdriver facilitates scheduling and communication between organizations and the staff they book.
      Audionola is not a party to the underlying engagement, staffing, or payment arrangement between an
      organization and its staff, and is not responsible for disputes arising from it.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Service availability</h2>
    <p>
      The Service is provided "as is." We aim for reliable availability but do not guarantee uninterrupted
      or error-free operation, and we may modify or discontinue features at any time.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Limitation of liability</h2>
    <p>
      To the maximum extent permitted by law, Audionola is not liable for indirect, incidental, or
      consequential damages arising from use of the Service.
    </p>

    <h2 class="text-h6 mt-6 mb-2">Changes</h2>
    <p>We may update these Terms from time to time. Continued use of the Service after a change constitutes acceptance of the updated Terms.</p>

    <h2 class="text-h6 mt-6 mb-2">Contact</h2>
    <p>Questions about these Terms can be sent to <a href="mailto:david@audionola.com">david@audionola.com</a>.</p>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAuthStore } from '../stores/auth';

const authStore = useAuthStore();
const backTarget = computed(() => (authStore.isAuthenticated ? '/' : '/login'));
</script>
